import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const list = async ({ contractId = '', ...params }) => {
  return await recurrenceAPI.get(`contracts/${contractId}/schedules`, {
    params,
  })
}

const details = async ({ contractId = '', scheduleId = '' }) => {
  return await recurrenceAPI.get(
    `contracts/${contractId}/schedules/${scheduleId}`,
  )
}

const scheduling = async ({ contractId = '', ...data }) => {
  return await recurrenceAPI.post(`contracts/${contractId}/schedules`, data)
}

const update = async ({ contractId = '', scheduleId = '', ...data }) => {
  return await recurrenceAPI.put(
    `/contracts/${contractId}/schedules/${scheduleId}`,
    data,
  )
}

const pause = async ({ contractId = '', ...data }) => {
  return await recurrenceAPI.put(`/contracts/${contractId}/pause`, data)
}

const activate = async ({ contractId = '' }) => {
  return await recurrenceAPI.put(`/contracts/${contractId}/activate`)
}

export default {
  list,
  details,
  scheduling,
  update,
  pause,
  activate,
}
